// Campaign brief (PDF) upload constraints, shared by the upload UI and its tests.
export const MAX_BRIEF_BYTES = 10 * 1024 * 1024; // 10MB
export const MAX_BRIEF_LABEL = '10MB';
export const ACCEPTED_BRIEF_TYPE = 'application/pdf';

/**
 * Result of validating a campaign brief. A discriminated union on `ok` so
 * callers narrow to the `error` message only on the failure branch.
 */
export type BriefValidation = { ok: true } | { ok: false; error: string };

// Validate a user-selected campaign brief before it is accepted for upload.
// Returns { ok: true } when valid, otherwise { ok: false, error } with a
// human-readable message suitable for a toast.
export function validateBrief(file: File | null | undefined): BriefValidation {
  if (!file) return { ok: false, error: 'No file selected' };

  const isPdf = file.type === ACCEPTED_BRIEF_TYPE || /\.pdf$/i.test(file.name || '');
  if (!isPdf) {
    return { ok: false, error: 'Campaign brief must be a PDF file' };
  }

  if (file.size > MAX_BRIEF_BYTES) {
    return { ok: false, error: `Campaign brief must be ${MAX_BRIEF_LABEL} or smaller` };
  }

  return { ok: true };
}
